


















import {Vue, Component, Prop, Inject} from 'vue-property-decorator';
import {API_BIS_PATENT_BATCHINDEXING, API_BIS_PATENT_CLEAN, API_BIS_PATENT_CLEANDATALIST} from "@/configs/Apis";
import {isEmptyOrWhiteSpace} from "@/utils/Common";
import {showConfirm, showSuccess, showWarning} from "@/utils/UI";

@Component
export default class BatchIndex extends Vue {
    @Prop({type: Boolean, default: () => false})
    visible!: boolean;

    @Prop({type: Array, default: () => [], required: true})
    patentIdList!: Array<string>;

    @Inject()
    projectId!: string;

    data: any = {};

    changed: boolean = false;

    get customFields() {
        return this.$store.getters["project/customfields"];
    }

    doCleanData() {
        if (!this.patentIdList || !this.patentIdList.length) {
            showWarning("请选择专利数据");
            return;
        }
        showConfirm("是否批量修改标引字段").then(() => {
            const postedData: Array<Array<string>> = [];
            Object.keys(this.data).forEach(key => postedData.push([key.replace("_", ''), this.data[key]]));
            this.$http.post({url: API_BIS_PATENT_BATCHINDEXING, path: {projectId: this.projectId}}, {patentIdList: this.patentIdList, indexingInfo: postedData}).then(() => {
                showSuccess("标引成功");
                this.changed = true;
                this.closeDialog();
            });
        });
    }

    closeDialog() {
        this.$emit("update:visible", false);
        if (this.changed) {
            this.$emit("data-changed");
        }
    }
}
